import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css';
import 'styles/Input.scss';
import 'styles/Alert.scss';
import 'styles/Layout.scss';
import 'styles/Button.scss';
import 'styles/Menu.scss';
import 'styles/Form.scss';
import 'styles/Popover.scss';
import 'styles/DatePicker.scss';
import 'styles/Modal.scss';
import 'styles/Switch.scss';
import 'styles/Table.scss';
import 'styles/Upload.scss';
import 'styles/Drawer.scss';
import 'styles/Progress.scss';


import 'styles/variables/_colors.scss';
import 'styles/variables/_typography.scss';
import 'styles/variables/_space.scss';
import 'styles/variables/_variables.scss';
import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import ConfigureStore from './redux/ConfigureStore';
let store = ConfigureStore();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
<App />
</Provider>
);


// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();